import { render, staticRenderFns } from "./text.vue?vue&type=template&id=ea1e30be&"
import script from "./text.vue?vue&type=script&lang=ts&"
export * from "./text.vue?vue&type=script&lang=ts&"
import style0 from "./text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports